import { Container, Item, Label, Description } from './MenuContent.styles';

interface IAddFieldContent {
  setOpenMenu: (bool: boolean) => void;
  onChange: (...event: any[]) => void;
}

const MenuContent = ({ setOpenMenu, onChange }: IAddFieldContent) => {
  return (
    <Container>
      <Item
        type="button"
        onClick={() => {
          setOpenMenu(false);
          onChange('Admin');
        }}
      >
        <Label>Admin</Label>
        <Description>
          Can do everything. Admins are the only ones capable of managing studio
          configurations and inviting users.
        </Description>
      </Item>
      <Item
        type="button"
        onClick={() => {
          setOpenMenu(false);
          onChange('Editor');
        }}
      >
        <Label>Editor</Label>
        <Description>Can do everything on inventory and tags.</Description>
      </Item>
      <Item
        type="button"
        onClick={() => {
          setOpenMenu(false);
          onChange('Member');
        }}
      >
        <Label>Member</Label>
        <Description>
          Can do read/edit existing inventory items and tags. Cannot add or
          delete anything.
        </Description>
      </Item>
      <Item
        type="button"
        onClick={() => {
          setOpenMenu(false);
          onChange('Viewer');
        }}
      >
        <Label>Viewer</Label>
        <Description>
          Only read access except user-specific configuration.
        </Description>
      </Item>
    </Container>
  );
};

export { MenuContent };
